import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "app-job-card-husk",
    templateUrl: "./job-card-husk.component.html",
    styleUrls: ["./job-card-husk.component.css"],
    standalone: true,
    imports: [CommonModule],
})
export class JobCardHuskComponent implements OnInit {
    @Input() darkMode = false;
    constructor() {}

    ngOnInit() {}
}
